import { wrap } from "comlink";

const CirclePackerCls = wrap(new Worker("./circlePacker.worker.js"));

export default CirclePackerCls;
